import { cn } from '@my/ui';
import { SAILING_TYPE_PILL } from '../lib/format';
import type { SailingType } from '../lib/mockData';

/** Sailing-type pill — off-peak green, peak amber, shoulder blue. Shared across
 *  the queues, the booking expand screen and the intelligence panel. */
export function SailingTypePill({ type }: { type: SailingType }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-1.5 py-0.5 text-[9px] font-medium ring-1 ring-inset',
        SAILING_TYPE_PILL[type],
      )}
    >
      {type}
    </span>
  );
}
